




































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'
import { maskDate, maskMoney, timeout } from '@/utils/common'
import { Loading } from '@/types/_'

@Component
export default class ViewBackofficeContratosDetails extends Vue {
  // Loaders
  rgsLoading: boolean = false
  gstLoading: boolean = false
  prfLoading: boolean = false
  loading: Loading = {
    status: false,
    text: '',
  }

  tb: string = 'tab-1'

  get regrasLoading() {
    return this.rgsLoading
  }

  set regrasLoading(value: boolean) {
    this.rgsLoading = value
  }

  get profissionaisLoading() {
    return this.prfLoading
  }

  set profissionaisLoading(value: boolean) {
    this.prfLoading = value
  }

  get gestoresLoading() {
    return this.gstLoading
  }

  set gestoresLoading(value: boolean) {
    this.gstLoading = value
  }

  get tabs() {
    return this.tb
  }

  set tabs(value: string) {
    this.tb = value
  }

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get contrato() {
    return this.getBackofficeContratosStore.contrato
  }

  get regrasTableHeader() {
    return this.getBackofficeContratosStore.regrasTableHeader
  }

  get profissionaisExibicaoTableHeader() {
    return this.getBackofficeContratosStore.profissionaisExibicaoTableHeader
  }

  get gestoresExibicaoTableHeader() {
    return this.getBackofficeContratosStore.gestoresExibicaoTableHeader
  }

  get loadingRequest() {
    return this.loading
  }

  set loadingRequest(value: Loading) {
    this.loading = value
  }

  get getRequestMessage() {
    return this.getBackofficeContratosStore.requestMessage
  }

  formatStatus(str: string) {
    switch (str.toLowerCase()) {
      case 'ativo':
        return { text: 'Ativo', color: 'success' }
      case 'inativo':
        return { text: 'Inativo', color: 'error' }
      default:
        return { text: 'Pendente', color: 'warning' }
    }
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest.status = status
    this.loadingRequest.text = text
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  formatMoney(value: string) {
    return maskMoney(value)
  }

  tabChange(e: string) {
    //
  }

  formatCPFOnly(c: string) {
    if (!c) return ''
    return `${c.substring(0, 3)}.${c.substring(3, 6)}.${c.substring(6, 9)}-${c.substring(9, 11)}`
  }

  maskDateUtil(date: string) {
    return maskDate(date)
  }

  displayPagamento(str: string) {
    switch (str.toLowerCase()) {
      case 'percentual':
        return 'Percentual'
      case 'valorfixo':
        return 'Fixo'
      default:
        return 'Cálculo'
    }
  }

  displayCNPJCPF(c: string) {
    if (!c) return '-'
    return (c.length && c.length === 14)
      ? `${c.substring(0, 2)}.${c.substring(2, 5)}.${c.substring(5, 8)}/${c.substring(8, 12)}-${c.substring(12, 14)}`
      : `${c.substring(0, 3)}.${c.substring(3, 6)}.${c.substring(6, 9)}-${c.substring(9, 11)}`
  }

  openRemoveRegra(id: string) {
    this.getBackofficeContratosStore.setRemoveRegraId(id)
    this.getBackofficeContratosStore.setShowModalRemoveRegraList(true)
  }

  openRemoveProfissional(id: string) {
    this.getBackofficeContratosStore.setRemoveProfissionalId(id)
    this.getBackofficeContratosStore.setShowModalRemoveProfissionalList(true)
  }

  openRemoveGestor(id: string) {
    this.getBackofficeContratosStore.setRemoveGestorId(id)
    this.getBackofficeContratosStore.setShowModalRemoveGestorList(true)
  }

  async getRegras() {
    this.regrasLoading = true
    await this.getBackofficeContratosStore.getAllRegras()
    this.regrasLoading = false
    this.getBackofficeContratosStore.setShowModalAddRegrasList(true)
  }

  getGestores() {
    this.getBackofficeContratosStore.setShowModalAddGestoresList(true)
  }

  getProfissionais() {
    this.getBackofficeContratosStore.setShowModalAddProfissionaisList(true)
  }

  async init() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await Promise.all([
      this.getBackofficeContratosStore.getContratoById(this.$route.params.id),
      this.getBackofficeContratosStore.getAllFontesPagadoras(),
    ])
    this.clearLoadingRequest()
  }

  async mounted() {
    await this.init()
  }

  getWindowWidth() {
    const doc: Document = document

    if (doc !== null) {
      const documentWidth = doc.documentElement.clientWidth
      const regrasTable = (doc.querySelector('.regras-table') as HTMLDivElement)
      const profissionaisTable = (doc.querySelector('.profissionais-table') as HTMLDivElement)
      const gestoresTable = (doc.querySelector('.gestores-table') as HTMLDivElement)
      regrasTable.style.width = (documentWidth < 576) ? `${documentWidth - 84}px` : '100%'
      profissionaisTable.style.width = (documentWidth < 576) ? `${documentWidth - 84}px` : '100%'
      gestoresTable.style.width = (documentWidth < 576) ? `${documentWidth - 84}px` : '100%'
    }
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  beforeDestroy() {
    this.getBackofficeContratosStore.clearRegras()
    this.getBackofficeContratosStore.clearGestores()
    this.getBackofficeContratosStore.clearProfissionaisExecutantes()
    this.getBackofficeContratosStore.clearContrato()
  }
}
